export default {
  products: null,
}
